module.exports = __webpack_public_path__ + "img/logoWhite.49b4ed41.svg";